import React from 'react';

const ZendeskTicketsTable: React.FC = () => {
  return <div>Zendesk table here</div>;
};

export default ZendeskTicketsTable;
